import { render, staticRenderFns } from "./LeavingPeriodModal.vue?vue&type=template&id=1038ecc1&scoped=true&"
import script from "./LeavingPeriodModal.vue?vue&type=script&lang=js&"
export * from "./LeavingPeriodModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038ecc1",
  null
  
)

export default component.exports